import React from "react";
import "./WordInfoModal.css";

const TranslationSection = ({ data }) => {
  if (!data?.dict || data.dict.length === 0) {
    return (
      <div className="wim-translation wim-translation--empty">
        <p>ترجمه‌ای یافت نشد</p>
      </div>
    );
  }

  const displayData = data.dict.map((item) => ({
    pos: item.pos || "nopos",
    translations: item.translations || [],
  }));

  return (
    <div className="wim-translation">
      <div className="wim-translation-groups">
        {displayData.map((item, itemIndex) => (
          <div key={itemIndex} className="wim-translation-row">
            <span className="wim-pos">{item.pos}</span>
            <span className="wim-pos-sep"> : </span>
            <span className="wim-translations">
              {item.translations.join("، ")}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TranslationSection;